<div class="py-2 pb-md-1 checkbox" [class.form-check-inline]="inline">
  <label class="form-check-label ms-1" [attr.for]="'checkbox-' + index + name">
    <input
      class="form-check-input"
      type="checkbox"
      tabindex="0"
      [id]="'checkbox-' + index + name"
      [name]="name"
      [attr.aria-label]="ariaLabel || null"
      [attr.aria-required]="ariaRequired ? true : null"
      [formControl]="control"
      nh-value
      [checkedValue]="checkedValue"
      [uncheckedValue]="uncheckedValue"
      [attr.disabled]="isDisabled"
      (click)="onCheckboxClick($event)"
      [style.cursor]="readonly ? 'not-allowed' : null"
    />
    <span class="cr" role="presentation" aria-hidden="true"
      ><i class="cr-icon fa fa-check" aria-hidden="true"></i
    ></span>
    @if (mandatory) {
    <span class="text-danger" aria-hidden="true">*</span>
    } @if (mandatory) {
    <span class="visually-hidden">{{ "required" | globalTranslate }}</span>
    } @if (fromCheckboxList && globalLangTranslate) {
    <span class="checkbox-l">{{ label | globalTranslate }}</span>
    } @if (fromCheckboxList && !globalLangTranslate) {
    <span class="checkbox-l">{{ label }}</span>
    } @if (!fromCheckboxList) {
    <span class="checkbox-l">{{ label }}</span>
    }
    <ng-content select="[checkbox-label]"></ng-content>
    <ng-content select="[checkbox-label]"></ng-content>
  </label>
  <ng-content></ng-content>
</div>